import {
  hasQuestionAnswer,
  normalizeExamQuestionStatus,
} from "../../../../shared/utilities/helpers/examQuestionStatus";

export const getQuestionStats = (questionsData = []) => {
  return questionsData.reduce(
    (acc, question, index) => {
      const status = normalizeExamQuestionStatus(question);

      if (status === "unvisited") acc.notVisited += 1;
      else if (status === "marked") acc.marked += 1;
      else if (status === "answered") acc.answered += 1;
      else if (status === "answered_marked") acc.answeredMarked += 1;
      else if (status === "unanswered") acc.notAnswered += 1;
      
      else if (status === "current") {
        acc.current = index + 1;
        const hasAnswer = hasQuestionAnswer(question);
        if (question?.marked) {
          if (hasAnswer) {
            acc.answeredMarked += 1;
          } else {
            acc.marked += 1;
          }
        } else if (hasAnswer) {
          acc.answered += 1;
        } else {
          acc.notAnswered += 1;
        }
      }

      return acc;
    },
    {
      notVisited: 0,
      marked: 0,
      answered: 0,
      answeredMarked: 0,
      notAnswered: 0,
      current: 0,
    }
  );
};
